var Bibliotheques = {
  _showModalUrl: null,

  showModal: function (url, navigation_reset) {
    var _modal = $("#default_modal").modal();
    var _title = _modal.find(".modal-title");
    var _body = _modal.find(".modal-body");
    var _data = {};

    _title.html("");
    _body.html('<div class="text-center">Chargement...</div>');

    if (navigation_reset) {
      Bibliotheques._showModalUrl = null;
    }

    if (Bibliotheques._showModalUrl) {
      _data = {
        history: Bibliotheques._showModalUrl,
      };
    }

    $.ajax({
      url: url,
      type: "GET",
      data: _data,
      success: function (e) {
        if (e.title || e.body) {
          _title.html(e.title);
          _body.html(e.body);
        } else {
          _title.html("");
          _body.html(e);
        }

        _modal.show();

        Bibliotheques._showModalUrl = url;

        $('[data-toggle="tooltip"]').tooltip();
      },
      error: function (e) {
        _title.html("Erreur");
        _body.html("Une erreur est survenue.");
      },
    });
  },

  imageShowModal: function () {
    var _modal = $("#default_modal").modal();
    var _title = _modal.find(".modal-title");
    var _body = _modal.find(".modal-body");
    var _imgSrc = $(this).data("modal-src");
    var _imgAlt = $(this).attr("alt");
    var _img = '<img class="img-fluid" src="' + _imgSrc + '" alt="' + _imgAlt + '">';

    _title.html($(this).attr("alt"));
    _body.html('<div class="text-center">' + _img + "</div>");
    _modal.show();
  },

  _initAutocomplete: function () {
    $('[data-item="autocomplete-container"] input').each(function (index, input) {
      $(input).typeahead(
        {
          hint: true,
          highlight: true,
          minLength: 3,
          selectOnBlur: true,
          changeInputOnSelect: true,
        },
        {
          limit: 50,
          async: true,

          templates: {
            suggestion: function (data) {
              return '<div data-item="autocomplete-item" class="autocomplete-item">' + data.display + "</div>";
            },
            empty: function (context) {
              return '<div class="autocomplete-empty">' + $(input).closest("div").data("empty-message") + "</div>";
            },
          },

          display: "value",

          updater: function (e) {},

          source: function (query, processSync, processAsync) {
            return $.ajax({
              url: $(input).closest("div").data("url"),
              type: "GET",
              data: {
                query: query,
              },
              dataType: "json",
              success: function (json) {
                return processAsync(json.response.items);
              },
            });
          },
        }
      );

      $(input).change(function () {
        var _current = $(input).typeahead("getActive");
        _current.closest("tr").find('[data-toggle="ajax-modal"]').hide();
      });
    });
  },

  exportData: function () {
    _form = $(this).closest("form");
    var _action = _form.prop("action");

    _action += "&export=true";

    location.href = _action;
  },

  init: function () {
    $("body").on("click", '[data-toggle="form-remove"]', function (event) {
      $(event.target).closest("td").find("input").val("");
      $(event.target).closest("td").find("select").val("");
      $(event.target).hide();
    });

    $("body").on("change", '[data-toggle="select-updater"]', function (event) {
      location.href = $(this).find("option:selected").data("url");
    });

    $("body").on("click", '[data-toggle="form-reset"]', function (event) {
      var _form = $(this).closest("form");
      _form.find("input").val("");
      _form.find("select").val("");
      _form.submit();
    });

    $("body").on("click", '[data-toggle="btn-show"]', function (event) {
      $(this).hide();
      _target = $(this).data("target");
      _query = '[data-item="' + _target + '"]';
      $(_query).fadeIn();
    });

    $("body").on("submit", '[data-toggle="comment-form"]', function (event) {
      event.preventDefault();

      var _form = $(this);
      var _btn = _form.find("button");

      _form.prop("disabled", "disabled");

      return $.ajax({
        url: _form.data("url"),
        type: "POST",
        data: _form.serializeArray(),
        dataType: "json",
        success: function (json) {
          _form.prop("disabled", null);

          if (json.response.success) {
            $('[data-item="comment-form-errors"]').hide();
            $('[data-item="comment-form-success"]').fadeIn();
            _form.hide();
          } else {
            $('[data-item="comment-form-errors"]').html(json.response.errors).fadeIn();
            $('[data-item="comment-form-success"]').hide();
            _form.show();
          }
        },
      });
    });

    $("body").on("click", '[data-toggle="ajax-modal"]', function (e) {
      Bibliotheques.showModal($(this).data("url"), $(this).data("navigation-reset") == 1);
    });

    $("body").on("click", '[data-toggle="bibliotheques-export"]', Bibliotheques.exportData);

    $("body").on("click", '[data-toggle="image-modal"]', Bibliotheques.imageShowModal);

    $("body").on("change", '[data-toggle="ajax-modal-select"]', function (e) {
      Bibliotheques.showModal($(this).find("option:selected").data("url"), false);
    });

    Bibliotheques._initAutocomplete();
  },
};

$(Bibliotheques.init);
